import '../../styles/auth.scss';
import { Outlet } from 'react-router-dom';
import { ReactComponent as BottomArc } from "./imgs/bottom-arc.svg";
import { ReactComponent as TopArc } from "./imgs/top-arc.svg";
import { useRef } from 'react';

function AuthLayout() {
  const windowWidth = useRef(window.innerWidth);

  return (
    <div className='flex px-4 md:px-10 py-10 min-h-screen items-center justify-center bg-gradient-to-b from-[#0000FF]/[1] to-[#0000FF]/[0.23] space-x-8 space-y-8 gap-y-8'>
      {/* children */}
      <div className="w-full pb-5 flex justify-center">
        <Outlet />
      </div>
      {windowWidth.current > 550 && (
        <>
          <BottomArc className='absolute left-[-200px] bottom-[0px]' />
          <TopArc className='absolute right-[-100px] top-[-50px]' />
        </>
      )}
    </div>
  );
}

export default AuthLayout;
